import { render, staticRenderFns } from "./DeltaScore.vue?vue&type=template&id=2d8685e2&scoped=true&"
import script from "./DeltaScore.vue?vue&type=script&lang=ts&"
export * from "./DeltaScore.vue?vue&type=script&lang=ts&"
import style0 from "./DeltaScore.vue?vue&type=style&index=0&id=2d8685e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8685e2",
  null
  
)

export default component.exports